import { TFeeInfo } from '../types/IGateway';

export const getGatewayFees = (
  gateway: any,
  currency: string | null | undefined,
): TFeeInfo[] | undefined => {
  if (gateway?.isRetryFees) {
    return currency && gateway?.fees ? gateway.fees?.[currency] : undefined;
  }

  const currencyFees = currency && gateway?.fees ? gateway.fees?.[currency] : undefined;

  if (currencyFees?.length) {
    return currencyFees;
  }

  const paymentInfoRaw = gateway?.payment_information;
  const paymentInfo = Array.isArray(paymentInfoRaw)
    ? paymentInfoRaw.find((info: any) => info.currency === currency) || paymentInfoRaw[0]
    : paymentInfoRaw;

  const gatewayDetailsPaymentInfoRaw = gateway?.gateway_details?.payment_information;
  const gatewayDetailsPaymentInfo = Array.isArray(gatewayDetailsPaymentInfoRaw)
    ? gatewayDetailsPaymentInfoRaw.find((info: any) => info.currency === currency) ||
      gatewayDetailsPaymentInfoRaw[0]
    : gatewayDetailsPaymentInfoRaw;

  const paymentInfoCurrency = paymentInfo?.currency || gatewayDetailsPaymentInfo?.currency;
  const paymentInfoFees = paymentInfo?.fees || gatewayDetailsPaymentInfo?.fees;

  if (
    Array.isArray(paymentInfoFees) &&
    paymentInfoFees.length > 0 &&
    (!currency || paymentInfoCurrency === currency)
  ) {
    return paymentInfoFees;
  }

  return undefined;
};
